import CompareContext from "@/context/compare/compare-context";
import CloseIcon from "../icons/CloseIcon";
import Image from "../global/Image";
import Link from "next/link";

import { useContext } from "react";
import { useTranslation } from "next-i18next";
import { usePathname } from "next/navigation";

const CompareProductFooter = () => {
  const compareCtx = useContext(CompareContext);
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  const pathname = usePathname();
  return (
    <>
      {(compareCtx.compareProducts.length > 0 && compareCtx?.showCompareFooter)  && (
        <>
          <div className="hidden max-lg:flex fixed bottom-0 bg-white py-7 px-6 md:px-11 w-full text-sm md:text-2xl font-bold shadow-compareFooter z-50 items-center justify-between mb-16 lg:mb-0">
            <div className="text-black">
              {t("Compare Products")} ({compareCtx.compareProducts.length})
            </div>
            <div className="text-xs lg:text-sm font-normal flex items-center gap-4">
              <button
                className="py-2 lg:py-3 px-4 lg:px-8 rounded-md border border-purple-800 text-black transition-all hover:text-white hover:bg-[#CD193A]"
                onClick={compareCtx.clearCompare}
              >
                {t("Delete All")}
              </button>
              {pathname !== "/compare" && (
                <Link
                  href={"/compare"}
                  className="py-2 lg:py-3 px-4 lg:px-8 rounded-md bg-primary text-white"
                >
                  {t("Compare")}
                </Link>
              )}
            </div>
          </div>
          <div className="fixed bottom-0 bg-black bg-opacity-60 py-7 px-6 md:px-11 font-bold w-full z-50 mb-16 lg:mb-0 hidden lg:flex max-w-[1920px]">
          <div 
          onClick={()=> compareCtx?.setShowCompareFooter(false)}
          className="text-white top-0 right-0 cursor-pointer text-xl border border-t-0 border-white size-8 p-2 absolute flex justify-center items-center"><p className="p-0 -mt-1">x</p></div>
            <div className="grid grid-cols-5 gap-5">
              {compareCtx?.compareProducts.map((product, idx) => (
                <div
                  key={idx}
                  className="px-4 font-bold py-4 border border-white relative bg-white flex items-center gap-2 min-h-[78px] max-h-[78px]"
                >
                  <Image
                    className="w-16 h-16 object-contain rounded-md"
                    src={product?._media_?.image[0].image}
                    alt="Compare Img!"
                  />
                  <p className="font-[400] line-clamp-2 text-black">
                    {product?.name[0] || ""}
                  </p>
                  <CloseIcon
                    onClick={() =>
                      compareCtx?.removeProductFromCompare(product)
                    }
                    className="absolute top-2 end-2 z-50 cursor-pointer text-black size-2"
                  />
                </div>
              ))}
              {[...Array(4 - compareCtx?.compareProducts.length).keys()].map(
                (i) => (
                  <div
                    key={i}
                    className="px-4 font-bold border border-dashed border-white flex items-center justify-center min-h-[78px] max-h-[78px]"
                  >
                    {language === "en"
                      ? "Add Item to compare"
                      : "أضف منتج إلى المقارنات"}
                  </div>
                )
              )}
              <Link
                href="/compare"
                className="py-4 rounded-md bg-primary text-white min-h-20 max-h-20 flex items-center justify-center"
              >
                {t("Compare")}
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CompareProductFooter;
